const mask = {
  methods: {
    formatCellphone(s) {
      this[s] = this[s].replace(/\D/g, "");
      const s1 = this[s].substring(0, 2);
      const s2 = this[s].substring(2, 7);
      const s3 = this[s].substring(7, 11);
      const len = this[s].length;
      if (len > 7) this[s] = `(${s1}) ${s2}-${s3}`;
      else if (len > 2) this[s] = `(${s1}) ${s2}`;
      else if (len > 0) this[s] = `(${s1}`;
    },

    formatPersonalId(s) {
      this[s] = this[s].replace(/\D/g, "");
      const s1 = this[s].substring(0, 3);
      const s2 = this[s].substring(3, 6);
      const s3 = this[s].substring(6, 9);
      const s4 = this[s].substring(9, 11);
      const len = this[s].length;
      if (len > 9) this[s] = `${s1}.${s2}.${s3}-${s4}`;
      else if (len > 6) this[s] = `${s1}.${s2}.${s3}`;
      else if (len > 3) this[s] = `${s1}.${s2}`;
    },

    formatBusinessId(s) {
      this[s] = this[s].replace(/\D/g, "");
      const s1 = this[s].substring(0, 2);
      const s2 = this[s].substring(2, 5);
      const s3 = this[s].substring(5, 8);
      const s4 = this[s].substring(8, 12);
      const s5 = this[s].substring(12, 14);
      const len = this[s].length;
      if (len > 12) this[s] = `${s1}.${s2}.${s3}/${s4}-${s5}`;
      else if (len > 8) this[s] = `${s1}.${s2}.${s3}/${s4}`;
      else if (len > 5) this[s] = `${s1}.${s2}.${s3}`;
      else if (len > 2) this[s] = `${s1}.${s2}`;
    },

    formatZipcode(s) {
      this[s] = this[s].replace(/\D/g, "");
      const s1 = this[s].substring(0, 2);
      const s2 = this[s].substring(2, 5);
      const s3 = this[s].substring(5, 8);
      const len = this[s].length;
      if (len > 5) this[s] = `${s1}.${s2}-${s3}`;
      else if (len > 2) this[s] = `${s1}.${s2}`;
    },

    formatMoney(value) {
      let val = (value / 100).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    formatPersonalIdOrEmail(inputname) {
      if (event.key !== "Backspace") {
        if (/^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}/.test(this[inputname])) {
          this[inputname] = `${this[inputname].substring(0, 14)}`;
        } else if (/^[0-9]{3}\.[0-9]{3}\.[0-9]{4}/.test(this[inputname])) {
          this[inputname] = `${this[inputname].substring(0, 11)}-${this[
            inputname
          ].substring(11)}`;
        } else if (/^[0-9]{3}\.[0-9]{4}/.test(this[inputname])) {
          this[inputname] = `${this[inputname].substring(0, 7)}.${this[
            inputname
          ].substring(7)}`;
        } else if (/^[0-9]{4}/.test(this[inputname])) {
          this[inputname] = `${this[inputname].substring(0, 3)}.${this[
            inputname
          ].substring(3)}`;
        }
      }
    },

    getCurrencySymbolBasedOnCurrency(currency) {
      return currency === "EUR" ? "€" : "R$";
    }
  },

  filters: {
    cellphoneWithCountryCode(v) {
      return `${v.substring(0, 3)} (${v.substring(3, 5)}) ${v.substring(5)}`;
    },
    cellphoneWithoutCountryCode(v) {
      return `(${v.substring(3, 5)}) ${v.substring(5)}`;
    }
  }
};

export { mask };
